import { render, staticRenderFns } from "./VStatisticInfoBlock.vue?vue&type=template&id=53e394fd&"
import script from "./VStatisticInfoBlock.vue?vue&type=script&lang=js&"
export * from "./VStatisticInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports